<template>
  <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43908 0.400294L14.6014 6.67979C14.7268 6.805 14.8266 6.9543 14.895 7.11906C14.9634 7.28381 14.9991 7.46075 15 7.63965C15.0009 7.81854 14.9669 7.99584 14.9002 8.16129C14.8334 8.32675 14.7351 8.47707 14.611 8.60357C14.4868 8.73006 14.3393 8.83023 14.1769 8.89827C14.0146 8.96632 13.8406 9.00089 13.665 8.99998C13.4895 8.99908 13.3158 8.96272 13.1541 8.89301C12.9925 8.8233 12.8459 8.72162 12.7231 8.59385L7.49051 3.26182L2.25795 8.59385C2.00801 8.84345 1.6715 8.98245 1.32156 8.98065C0.971607 8.97885 0.636495 8.83639 0.38904 8.58423C0.141585 8.33207 0.00178432 7.99059 1.71661e-05 7.63399C-0.00174999 7.27738 0.134657 6.93448 0.3796 6.67979L6.5406 0.400294C6.7922 0.143986 7.13341 0 7.48917 0C7.84494 0 8.18614 0.143986 8.43774 0.400294H8.43908Z" fill="#393E42"/>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
